import { apiClient } from "./client";
import type { Assignment } from "./types";

export type SwapStatus =
  | "PROPOSED"
  | "ACCEPTED"
  | "REJECTED"
  | "CANCELLED"
  | "EXPIRED";

export type SwapProposal = {
  id: string;
  status: SwapStatus;
  message: string | null;
  decision_reason: string | null;
  decided_at: string | null;
  created_at: string;
  proposer_user_id: string;
  proposer_practitioner_id: string;
  proposer_assignment: Assignment;
  proposer_display: string;
  target_user_id: string;
  target_practitioner_id: string;
  target_assignment: Assignment;
  target_display: string;
  direction: "outgoing" | "incoming";
};

export type SwapDirection = "outgoing" | "incoming" | "all";

export async function listSwapProposals(
  direction: SwapDirection = "all",
  status?: SwapStatus,
): Promise<SwapProposal[]> {
  const { data } = await apiClient.get<SwapProposal[]>("/api/v1/me/swap-proposals", {
    params: { direction, status },
  });
  return data;
}

export async function createSwapProposal(
  myAssignmentId: string,
  targetAssignmentId: string,
  message?: string,
): Promise<SwapProposal> {
  const { data } = await apiClient.post<SwapProposal>("/api/v1/me/swap-proposals", {
    my_assignment_id: myAssignmentId,
    target_assignment_id: targetAssignmentId,
    message: message || null,
  });
  return data;
}

export async function acceptSwap(id: string, reason?: string): Promise<SwapProposal> {
  const { data } = await apiClient.post<SwapProposal>(
    `/api/v1/me/swap-proposals/${id}/accept`,
    { reason: reason || null },
  );
  return data;
}

export async function rejectSwap(id: string, reason?: string): Promise<SwapProposal> {
  const { data } = await apiClient.post<SwapProposal>(
    `/api/v1/me/swap-proposals/${id}/reject`,
    { reason: reason || null },
  );
  return data;
}

export async function cancelSwap(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/me/swap-proposals/${id}`);
}
